<div class="modal-header">
  <h5 class="modal-title">მეტა მონაცემები</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<form [formGroup]="form">
    <div class="modal-body">
      <div class="form-floating mb-3">
      <textarea
        class="form-control"
        id="meta_desc"
        formControlName="meta_desc"
      ></textarea>
      <label for="meta_desc">მეტა აღწერა</label>
    </div>

    <div class="form-floating mb-3">
      <textarea
        class="form-control"
        id="meta_keys"
        formControlName="meta_keys"
      ></textarea>
      <label for="meta_keys">მეტა სიტყვები</label>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">დახურვა</button>
    <button type="button" class="btn btn-primary" (click)="onSave()">შენახვა</button>
  </div>
</form>

